import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Application } from '@modules/common/types/application';
import { VirtualFolder } from '@modules/contacts/types/virtual-folder';
import { AdvancedSearchService } from '@modules/search/services/advanced-search.service';

@Component({
  selector: 'app-contacts-list-context-menu',
  templateUrl: './contacts-context-menu.component.html',
  styleUrls: ['./contacts-context-menu.component.less'],
  standalone: false,
})
export class ContactsContextMenuComponent {
  // Input
  @Input() filterKey: VirtualFolder;

  // Outputs
  @Output() change = new EventEmitter<VirtualFolder>();

  protected readonly searchService = inject(AdvancedSearchService);
  protected readonly isAdvancedSearchApplied = toSignal(
    this.searchService.isAdvancedSearchApplied(Application.contacts),
    {
      initialValue: false,
    },
  );

  selectFilter(filter: VirtualFolder) {
    this.change.emit(filter);
  }
}
